/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tools_Drive_ListInputs */

const es_tools_drive_list = /** @type {(inputs: Tools_Drive_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listando carpeta de Drive...`)
};

const en_tools_drive_list = /** @type {(inputs: Tools_Drive_ListInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Listing Drive folder...`)
};

/**
* | output |
* | --- |
* | "Listing Drive folder..." |
*
* @param {Tools_Drive_ListInputs} inputs
* @param {{ locale?: "es" | "en" }} options
* @returns {LocalizedString}
*/
const tools_drive_list = /** @type {((inputs?: Tools_Drive_ListInputs, options?: { locale?: "es" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tools_Drive_ListInputs, { locale?: "es" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_tools_drive_list(inputs)
	return en_tools_drive_list(inputs)
});
export { tools_drive_list as "tools.drive.list" }